import { render, staticRenderFns } from "./ServicesComponent.vue?vue&type=template&id=6a9f6f07&scoped=true"
import script from "./ServicesComponent.vue?vue&type=script&lang=js"
export * from "./ServicesComponent.vue?vue&type=script&lang=js"
import style0 from "./ServicesComponent.vue?vue&type=style&index=0&id=6a9f6f07&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9f6f07",
  null
  
)

export default component.exports